/* eslint-disable react/prop-types */

import React from 'react';
import moment from 'moment';
import { Tooltip, Button, Tag } from 'antd';

import AppVersion from '../../components/AppVersion';
import ShowMore from '../../components/commons/ShowMore';

const styles = {
  tag: {
    marginLeft: -2,
  },
};

function generateMeta(key) {
  return { key, dataIndex: key };
}

function renderTags(tags) {
  if (!tags || !(tags && tags.length)) {
    return '';
  }
  const [tag] = tags;
  if (tags.length === 1) {
    return (
      <Tag color="orange" key={tag}>
        {tag}
      </Tag>
    );
  }
  return (
    <>
      <Tooltip placement="bottom" title={tags.join(', ')}>
        <Tag color="orange" key={tag}>
          {tag}
        </Tag>
        <Tag color="orange" key="..." style={styles.tag}>
          {'...'}
        </Tag>
      </Tooltip>
    </>
  );
}

const columns = [
  {
    title: 'Time',
    width: 100,
    isSortable: true,
    render: time => moment(time).format('YYYY-MM-DD HH:mm'),
    ...generateMeta('dateTime'),
  },
  {
    title: 'Direction',
    width: 120,
    isSortable: true,
    ...generateMeta('direction'),
  },
  {
    title: 'Games',
    width: 100,
    isSortable: true,
    ...generateMeta('game'),
    render: game => renderTags(game),
  },
  {
    title: 'Platforms',
    width: 120,
    isSortable: true,
    ...generateMeta('platform'),
    render: platform => renderTags(platform),
  },
  {
    title: 'Event Type',
    width: 150,
    isSortable: true,
    ...generateMeta('eventType'),
  },
  {
    title: 'Description',
    render: text => <ShowMore>{text}</ShowMore>,
    ...generateMeta('description'),
  },
  {
    title: 'App Version',
    width: 120,
    isSortable: true,
    ...generateMeta('appVersion'),
    render: (text, { payload }) => <AppVersion {...payload} />,
  },
  {
    title: 'Audience',
    ...generateMeta('audience'),
    render: (text, { payload }) => (
      <ShowMore>{payload.audience || ''}</ShowMore>
    ),
  },
  {
    title: 'Channel',
    width: 170,
    ...generateMeta('channel'),
    render: (text, { payload }) => renderTags(payload.channel),
  },
  {
    title: 'Server Version',
    width: 140,
    isSortable: true,
    ...generateMeta('serverVersion'),
    render: (text, { payload }) => payload.serverVersion,
  },
  {
    title: 'Engine Version',
    width: 140,
    isSortable: true,
    ...generateMeta('engineVersion'),
    render: (text, { payload }) => payload.engineVersion,
  },
  {
    title: 'Notes',
    width: 75,
    render: (notes, { payload }) => {
      const { notesLink } = payload;

      if (!notesLink) {
        return null;
      }

      let text = 'Link';

      if (notesLink && notesLink.includes('https://jira.murka.com/browse/')) {
        const splitted = notesLink.split('/');
        text = splitted[splitted.length - 1];
      }

      return (
        <Button
          type="link"
          href={notesLink}
          target="_blank"
          style={{ lineHeight: '14px', height: 14, padding: 0 }}
        >
          {text}
        </Button>
      );
    },
    ...generateMeta('notesLink'),
  },
  {
    title: 'Responsible',
    width: 170,
    isSortable: true,
    ...generateMeta('responsible'),
  },
  {
    title: 'Resolution Date',
    width: 170,
    isSortable: true,
    ...generateMeta('resolutionDate'),
    render: (text, { payload }) =>
      payload.resolutionDate &&
      moment(payload.resolutionDate).format('YYYY-MM-DD HH:mm'),
  },
  {
    title: 'Class Tag',
    width: 140,
    isSortable: true,
    ...generateMeta('classTag'),
    render: (text, { payload }) => payload.classTag,
  },

  {
    title: 'Type Tag',
    width: 140,
    isSortable: true,
    ...generateMeta('typeTag'),
    render: (text, { payload }) => payload.typeTag,
  },
  {
    title: 'Tech Tag',
    width: 140,
    isSortable: true,
    ...generateMeta('techTag'),
    render: (text, { payload }) => payload.techTag,
  },
];

export default columns;
